import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';

import { MixpanelContext } from 'Context/AnalyticsContext/MixPanelProvider';

export const withMixpanel = (Component) => {
  const MixpanelWrapperComponent = (props) => (
    <MixpanelContext.Consumer>
      {(mixpanel) => <Component {...props} mixpanel={mixpanel} />}
    </MixpanelContext.Consumer>
  );
  return hoistNonReactStatic(MixpanelWrapperComponent, Component);
};
